import { useEffect } from 'react';
import { autorun } from 'mobx';
import useInfraStores from '@app/hooks/useInfraStores';
import { setIdentity } from './analytics';
import type { Identity } from './types';

function toIdentity(user: AppUser | undefined, organization: UserOrganization | undefined): Identity | null {
  if (!user) return null;
  return {
    user_id: user.analyticsId || user.id,
    client_name: organization?.data?.name,
  };
}

export function useIdentitySync(): void {
  const { userStore } = useInfraStores();

  useEffect(() => {
    return autorun(() => {
      setIdentity(toIdentity(userStore.user, userStore.selectedOrganization));
    });
  }, [userStore]);
}
